import { can } from 'services/can';
import { PermissionsMapping } from 'common/constants/role-intents';

/**
 * Whether the user can use business report jobs (sidebar “Reports”, `/reports`).
 *
 * Same check as `options.reports.auth` in `containers/sidebar/index.js` (`campaign__view`).
 * Analysts may still have `report__view` for per-campaign reports; that does not apply here.
 *
 * @param {string} [globalRole] - Redux `profile.globalRole`; when omitted, `can()` uses the store.
 * @returns {boolean}
 */
export function canUseReportJobs(globalRole) {
    return can(PermissionsMapping.CAMPAIGN__VIEW, globalRole);
}

/**
 * Whether the user can create, update, or delete business reports.
 *
 * This mirrors the authorization applied to the Urban business-report mutation routes.
 *
 * @param {string} [globalRole] - Redux `profile.globalRole`; when omitted, `can()` uses the store.
 * @returns {boolean}
 */
export function canManageBusinessReports(globalRole) {
    return can(PermissionsMapping.CAMPAIGN__VIEW_AND_EDIT, globalRole);
}
